// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"styles_checkboxGroup__9ZDBQ","label":"styles_label__dwrIB","checkboxGroupItems":"styles_checkboxGroupItems__qZxCS"};